import OnboardingIcon from "./OnboardingIcon/OnboardingIcon";
import "./OnboardingMobileContent.css"


const OnboardingMobileContent = (props) => {
    return ( <div className="box">
        <OnboardingIcon iconName={props.content.icon}/>
        <p className="onboarding-text">{props.content.line1}</p>
        <p className="onboarding-text">{props.content.line2}</p>
    </div> );
}
 
export default OnboardingMobileContent;